"use client";

import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col sm:flex-row gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm transition-all duration-[var(--duration-medium)] hover:tracking-wider hover:text-primary">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <footer id="footer" className="w-full text-foreground-dark py-12 px-6 !bg-[hsl(210,20%,98%)]">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {}
          <div className="flex justify-center !bg-transparent md:justify-start">
            <Link to="/HomePage#" aria-label="RR Recovery Solution Home">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548353/img/rr_recovery_solution_footer_logo.png" alt="RR Recovery Solution Logo" className="h-7" />
            </Link>
          </div>

          {}
          <div className="flex justify-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} newTab aria-label={social.label} data-index={i} className="text-foreground-dark/70 hover:text-primary transition-all duration-[var(--duration-medium)] hover:brightness-125 hover:-translate-y-1">
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>

          {}
          <div className="flex justify-center md:justify-end">
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        {}
        <Separator className="my-8 opacity-10" />

        {}
        <div className="text-center">
          <p className="text-sm !text-[hsl(0,0%,0%)]">
            © {new Date().getFullYear()} RR Recovery Solution. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}